import ConsentService from './ConsentService';
import { Consent, ConsentCategory } from './constants';
import useConsentListener from './useConsentListener';

export { useConsentListener, type Consent, ConsentCategory };

export default ConsentService;
